import { ChangeDetectorRef, Component, OnDestroy } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { NumericFilterCellComponent } from "@progress/kendo-angular-grid";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { take } from "rxjs/operators";
import { Customer } from "src/app/frontoffice/parties/model/customer.model";
import { SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { ClubEnum } from "../../../model/club.enum";
import { ClubConfirmationEnum } from "../../../model/clubconfirmation.enum";
import { OrderService } from "../../../order.service";
import { ItemOrderService } from "../../item/itemorder.service";
import { ClubConfirmationComponent } from "./clubconfirmation/clubconfirmation.component";
import { ClubViewModel, SmartClubModel, UsedProductDiscount } from "../../../model/smartclub.model";
import { CustomerFormComponent } from "src/app/frontoffice/parties/customer/customer-form.component";
import { of } from "rxjs";

@Component({
  selector: "order-clubfastacces",
  templateUrl: "./orderclubfastacces.component.html",
  styleUrls: ["./orderclubfastacces.component.scss"],
  providers: [ItemOrderService],
})
export class ClubFastAccessComponent extends BaseFormComponent<ClubViewModel> implements OnDestroy {
  clubAction: number;
  clubActionEnum: NumericFilterCellComponent;
  public clubModelEnum: typeof ClubEnum = ClubEnum;
  constructor(
    protected selectorService: SelectorService,
    public order: OrderService,
    public cd: ChangeDetectorRef,
    public itemService: ItemOrderService
  ) {
    super(selectorService, cd);
    this.order.cd_FastAccessClub = cd;
    this.apiName = "";
    this.areaName = "";
    this.label = "";
  }
  ngOnDestroy(): void {}
  FillData() {
    let group: any = {};
    this.formGroup = new UntypedFormGroup(group);
    this.model = this.order.invoice.ClubViewModel;
    if (!this.model?.Code && !this.model?.LongMobile) {
      this.model = new ClubViewModel();
    }
    const club = this.order.invoice.ClubViewModel;
    this.setValue("CreditCode", club?.Code ? club?.Code : club?.LongMobile ? "0" + `${club?.LongMobile}` : null);
    this.setValue("Phone", club?.LongMobile ? "0" + `${club?.LongMobile}` : "");
    this.setValue("UseCredit", club?.usedCredit);
    this.setValue("OperatorPhone", club?.OperatorPhone);
  }
  async ngOnInit() {
    this.FillData();
  }
  SendCodeToCustomer() {
    if (!this.formGroup.controls["Phone"].value) {
      this.sts.showToast(
        "warning",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.PhoneNotEntered")
      );
      return;
    }
    this.order.splashFormService.openDialog();
    const mobileNumber = this.formGroup.controls["Phone"].value;
    const branchId = this.order.logInBranch.Id;
    this.httpCommonService
      .getList(`Invoice/SendCodeToCustomer/${mobileNumber}/${branchId}`)
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          this.order.splashFormService.closeLoading();
          if (!data) {
            this.sts.showDialog(
              `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Send")}`,
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error")
            );
            return;
          }
          this.sts.showToast("success", "", this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ClubCodeSentToCustomer"));
        },
        (err) => {
          this.order.splashFormService.closeLoading();
          console.log(err);
        }
      );
  }
  GetCustomerInquiry() {
    if (!this.order.invoice.ClubViewModel) this.order.invoice.ClubViewModel = new ClubViewModel();
    if (!this.formGroup.controls["CreditCode"].valid) return;
    if (this.order.invoice.Items?.length <= 0) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.BasketIsEmpty"),
        600
      );
      return;
    }
    if (this.order.invoice.TotalDiscount > 0) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.InvoiceDiscountOrderToUsecredit"),
        600
      );
      return;
    }
    if (!this.formGroup.controls["CreditCode"].value) {
      this.sts.showToast(
        "warning",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.PhoneNotEntered")
      );
      return;
    }
    this.reset();
    this.order.splashFormService.openDialog();
    const clubModel = new SmartClubModel();
    clubModel.codeOrMobile = this.formGroup.controls["CreditCode"].value;
    clubModel.posUserId = this.order.currentUser.Id.toString();
    switch (this.order.currentSaleMethodNature) {
      case SaleMethodNature.Restaurant:
        clubModel.orderType = 1;
        break;
      case SaleMethodNature.Delivery:
        clubModel.orderType = 2;
        break;
      case SaleMethodNature.FastFood:
        clubModel.orderType = 3;
        break;
      default:
        clubModel.orderType = 4;
        break;
    }
    clubModel.retry = false;
    clubModel.InvoiceId = this.order.invoice.Id;
    clubModel.BranchId = this.order.invoice.BranchId;
    this.httpCommonService
      .create(`Invoice/GetCustomerInquiry`, clubModel)
      .pipe(take(1))
      .subscribe(
        (data: ClubViewModel) => {
          this.order.splashFormService.closeLoading();
          if (data.CustomerInquiryResponseStatus < 1) {
            this.sts.showToast("danger", this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error"), data.Message, 3000);
            return;
          }
          //اگر مشترک بدون اشتراک انتخاب شده
          if (data?.Customer?.Id && this.order.invoice.Customer?.Id !== data?.Customer?.Id) {
            if (this.order.invoice.Customer?.Id === this.order.defaultCustomerId) {
              this.order.invoice.CustomerId = data.Customer.Id;
              this.order.invoice.ShippingCost = data.Customer.ShippingCost;
              this.order.setValue("ShippingCost", this.order.invoice.ShippingCost);
              this.order.invoice.CourierShippingCost = data.Customer.CourierShippingCost;
              this.order.invoice.Customer.Number = data.Customer.Party.Number;
              this.order.invoice.CustomerDisplayName = data.Customer.DisplayName;
              this.order.invoice.PhoneNumber = data.Customer.PhoneNumber;
              this.order.invoice.PhoneId = data.Customer?.Numbers?.find((f) => f.IsDefault)?.Id;
              this.order.invoice.AddressId = data.Customer.Addresses?.find((f) => f.IsDefault)?.Id;
              this.order.invoice.CustomerAddress = data.Customer.Addresses?.find((f) => f.IsDefault);
              this.order.invoice.Customer = data.Customer;
              this.order.calculate();
              if (this.CalculatePayableTotla()) {
                const ClubDiscount = this.order.invoice.ClubViewModel.DiscountPrice;
                if (data.AvailableCredit + (ClubDiscount ? ClubDiscount : 0) > this.CalculatePayableTotla()) {
                  const diff = this.CalculatePayableTotla() - (ClubDiscount ? ClubDiscount : 0);
                  this.setValue("UseCredit", diff);
                  this.order.invoice.ClubViewModel.usedCredit = diff;
                } else {
                  this.setValue("UseCredit", data.AvailableCredit);
                  this.order.invoice.ClubViewModel.usedCredit = data.AvailableCredit;
                }
              }
            } else {
              this.dialogService
                .open(ClubConfirmationComponent, { errorMessage: "NotFound!!!" }, { closeOnClickOutside: false })
                .pipe(take(1))
                .subscribe((res: ClubConfirmationEnum) => {
                  switch (res) {
                    case ClubConfirmationEnum.Save:
                      this.order._opened = true;
                      break;
                    case ClubConfirmationEnum.Cancel:
                      this.Reset();
                      return;
                    case ClubConfirmationEnum.Replace:
                      this.order.invoice.CustomerId = data.Customer.Id;
                      this.order.invoice.ShippingCost = data.Customer.ShippingCost;
                      this.order.setValue("ShippingCost", this.order.invoice.ShippingCost);
                      this.order.invoice.CourierShippingCost = data.Customer.CourierShippingCost;
                      this.order.invoice.Customer.Number = data.Customer.Party.Number;
                      this.order.invoice.CustomerDisplayName = data.Customer.DisplayName;
                      this.order.invoice.PhoneNumber = data.Customer.PhoneNumber;
                      this.order.invoice.PhoneId = data.Customer?.Numbers?.find((f) => f.IsDefault)?.Id;
                      this.order.invoice.AddressId = data.Customer.Addresses?.find((f) => f.IsDefault)?.Id;
                      this.order.invoice.CustomerAddress = data.Customer.Addresses?.find((f) => f.IsDefault);
                      this.order.invoice.Customer = data.Customer;
                      this.order.calculate();
                      if (this.CalculatePayableTotla()) {
                        const ClubDiscount = this.order.invoice.ClubViewModel.DiscountPrice;
                        if (data.AvailableCredit + (ClubDiscount ? ClubDiscount : 0) > this.CalculatePayableTotla()) {
                          const diff = this.CalculatePayableTotla() - (ClubDiscount ? ClubDiscount : 0);
                          this.setValue("UseCredit", diff);
                          this.order.invoice.ClubViewModel.usedCredit = diff;
                        } else {
                          this.setValue("UseCredit", data.AvailableCredit);
                          this.order.invoice.ClubViewModel.usedCredit = data.AvailableCredit;
                        }
                      }
                      this.order._opened = true;
                      break;
                    default:
                      this.Reset();
                      return;
                  }
                  this.order.detectChanges();
                });

              // this.sts.showDialog(`مشتری تعریف در باشگاه مشتریان با مشتری انتخاب شده برابر نمی باشد ایا مایل به ادامه می باشید ؟  `, 'عدم تطابق کد اشتراک', DialogType.confirm, () => {
              //   setTimeout(() => { this.order._opened = true; },100);
              // }, () => { this.Reset(); return; }, "جایگذاری");

              /**/
            }
          }
          this.order.invoice.ClubViewModel = data;

          this.order.invoice.ClubViewModel.UsedProductDiscount = [];
          if (data.ProductDiscounts && data.ProductDiscounts.length > 0) {
            data.ProductDiscounts.forEach((element) => {
              if (!this.order.invoice.Items.some((s) => s.IsClubItem && s.ItemId === element.ProductId)) {
                const findOrderItem = this.order.itemCategoryList[0].Items.find((f) => f.Id === element.ProductId);
                findOrderItem.IsClubItem = true;
                this.itemService.setSelectedItem(findOrderItem, element.QuantityRemain);
                this.order.selectedInvoiceItem.RowDiscount = element.Percentage;
                const findInvoiceIndex = this.order.invoice.Items.findIndex((i) => i.ItemId === element.ProductId);
                this.order.formGroup.controls[`RowDiscount${findInvoiceIndex}`].setValue(element.Percentage);
                const usedProductDiscount = new UsedProductDiscount();
                usedProductDiscount.ProductId = element.ProductId;
                usedProductDiscount.UsedCount = element.QuantityRemain;
                this.order.invoice.ClubViewModel.UsedProductDiscount.push(usedProductDiscount);
                this.order.calculate();
                if (this.CalculatePayableTotla()) {
                  const ClubDiscount = this.order.invoice.ClubViewModel.DiscountPrice;
                  if (data.AvailableCredit + (ClubDiscount ? ClubDiscount : 0) > this.CalculatePayableTotla()) {
                    const diff = this.CalculatePayableTotla() - (ClubDiscount ? ClubDiscount : 0);
                    this.setValue("UseCredit", diff);
                    this.order.invoice.ClubViewModel.usedCredit = diff;
                  } else {
                    this.setValue("UseCredit", data.AvailableCredit);
                    this.order.invoice.ClubViewModel.usedCredit = data.AvailableCredit;
                  }
                }
              }
            });
          }
          this.order.calculate();
          if (this.CalculatePayableTotla()) {
            const ClubDiscount = this.order.invoice.ClubViewModel.DiscountPrice;
            if (data.AvailableCredit + (ClubDiscount ? ClubDiscount : 0) > this.CalculatePayableTotla()) {
              const diff = this.CalculatePayableTotla() - (ClubDiscount ? ClubDiscount : 0);
              this.setValue("UseCredit", diff);
              this.order.invoice.ClubViewModel.usedCredit = diff;
            } else {
              this.setValue("UseCredit", data.AvailableCredit);
              this.order.invoice.ClubViewModel.usedCredit = data.AvailableCredit;
            }
          }
        },
        (err) => {
          this.order.splashFormService.closeLoading();
          console.log(err);
        }
      );
  }
  /// Calculate PayableTotla
  private CalculatePayableTotla(): number {
    const payable =
      this.order.invoice.PayableTotal -
      this.order.invoice.TotalTax -
      this.order.invoice.RoundingAmount -
      this.order.invoice.TotalToll -
      this.order.invoice.TotalService +
      (this.order.invoice.TotalDiscount ? this.order.invoice.TotalDiscount : 0);
    return payable;
  }

  showCustomerForm() {
    if (!this.order.invoice.Items.length) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ItemNotSelected"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error")
      );
      return of(true);
    }
    if (this.order.invoice.CustomerNumber === 0) {
      this.dialogService
        .open(
          CustomerFormComponent,
          {
            label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.NoSubscription"),
            hasClubCustomer: true,
            nameIsNotNecessary: !this.order.saleMethodBranch.HasNecessaryName,
            apiName: "Customer",
            LastName: this.order.invoice.Customer.LastName,
            currentrow: null,
          },
          { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false }
        )
        .pipe(take(1))
        .subscribe((res) => {
          if (res) {
            this.httpCommonService
              .getItem("Customer/GetCustomerDetails", res.Id)
              .pipe(take(1))
              .subscribe((customer: Customer) => {
                this.order.invoice.Customer = customer;
                this.order.invoice.CustomerId = customer.Id;
                this.order.invoice.Customer.Number = customer.Number;
                this.order.invoice.CustomerDisplayName = customer?.LastName;
                this.order.invoice.PhoneNumber = customer.PhoneNumber;
                this.order.invoice.PhoneId = customer?.Numbers?.find((f) => f.IsDefault)?.Id;
                this.order.invoice.CustomerAddres = customer.Address;
                this.order.invoice.AddressId = customer.Addresses?.find((f) => f.IsDefault)?.Id;
                this.order.detectChanges();
              });
            return of(true);
          } else {
            return of(true);
          }
        });
    } else {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.SharedMobileNumberRegistered"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error")
      );
      this.order.detectChanges();
      return of(true);
    }
    this.cd.markForCheck();
    this.order.detectChanges();
  }

  /// Use CreditPrice in Invoice As DiscountPrice
  UseCredit() {
    this.order.invoice.ClubViewModel.usedCredit = 0;
    this.order.invoice.ClubViewModel.UseCreditPrice = 0;
    this.order.calculate();
    this.order.invoice.HasClub = true;
    this.order.invoice.ClubCode = this.order.invoice.ClubViewModel?.UsedCreditResponseId;
    // if(!this.CalculatePayableTotla()) {this.sts.showToast('warning','کالایی انتخاب نشده است','فاکتور خالی'); return;}
    if (this.CalculatePayableTotla() < this.order.invoice.ClubViewModel.MinFactorPriceToActiveDiscountPercent) {
      const minimumPriceWithComma = this.order.invoice.ClubViewModel.MinFactorPriceToActiveDiscountPercent?.toString().replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );
      this.sts.showToast(
        "warning",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.MinimumInvoiceAmount"),
        `${this.translate(
          "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.AmountShoppingCartLessThanMinimumAmount"
        )} ${minimumPriceWithComma}`,
        2000
      );
      return;
    }
    if (this.formGroup.controls["UseCredit"].value > this.CalculatePayableTotla()) {
      this.sts.showToast(
        "warning",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.CreditUsageRate"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.AmountOfCreditGreaterThanSumOfInvoices"),
        2000
      );
      return;
    }
    if (this.CalculatePayableTotla()) {
      const ClubDiscount = this.order.invoice.ClubViewModel.DiscountPrice;
      this.order.invoice.ClubViewModel.usedCredit = this.formGroup.controls["UseCredit"].value ? this.formGroup.controls["UseCredit"].value : 0;
      this.order.invoice.ClubViewModel.UseCreditPrice = (ClubDiscount ? ClubDiscount : 0) + this.order.invoice.ClubViewModel.usedCredit;
    }
    /// تنظیم تخفیف ریالی
    //if (!this.order.formGroup.controls["Discount"].value && this.order.invoice.ClubViewModel.ClubTotalDiscount <= this.CalculatePayableTotla()) {
    //  this.order.invoice.IsDiscountPercent = false;
    //  this.order.invoice.ClubViewModel.ClubTotalDiscount = this.order.invoice.ClubViewModel.UseCreditPrice + this.order.invoice.ClubViewModel.DiscountPrice;
    //  this.order.formGroup.controls["Discount"].setValue(this.order.invoice.ClubViewModel.ClubTotalDiscount);
    //  this.order.invoice.ClubViewModel.usedCredit = this.formGroup.controls["UseCredit"].value;
    if (this.order.invoice.ClubViewModel.DiscountPrice > 0) {
      this.order.invoice.ClubViewModel.usedDiscountPercent = this.order.invoice.ClubViewModel.DiscountPercent;
    }
    //}
    /// ccc تخفیف کلی در صورت وجود باشگاه
    if (this.order.invoice?.HasClub) {
      const discount = this.order.invoice?.ClubViewModel?.UseCreditPrice ? this.order.invoice?.ClubViewModel?.UseCreditPrice : 0;
      this.order.invoice.IsDiscountPercent = false;
      this.order.invoice.DiscountPrice = discount;
      this.order.invoice.Discount = discount;
      this.order.setValue("Discount", discount);
    }
    this.order.calculate();
    // this.order.formGroup.controls["Discount"].disable();
    // this.cd.markForCheck();
    this.order._opened = false;
  }
  /// CreditPriceChange
  CreditPriceChange(value) {
    if (value !== this.order.invoice.ClubViewModel.usedCredit) {
      if (this.CalculatePayableTotla()) {
        const ClubDiscount =
          (this.order.invoice.TotalWidthRowDiscount *
            (this.order.invoice.ClubViewModel.DiscountPercent ? this.order.invoice.ClubViewModel.DiscountPercent : 0)) /
          100;
        if (this.order.invoice.ClubViewModel.AvailableCredit + (ClubDiscount ? ClubDiscount : 0) > this.CalculatePayableTotla()) {
          const diff = this.CalculatePayableTotla() - (ClubDiscount ? ClubDiscount : 0);
          if (value > diff) this.setValue("UseCredit", diff);
          else {
            this.order.invoice.ClubViewModel.usedCredit = value;
            this.order.invoice.ClubViewModel.isDisableusedCredit = true;
          }
        }
        if (this.order.invoice.ClubViewModel.AvailableCredit + (ClubDiscount ? ClubDiscount : 0) < this.CalculatePayableTotla()) {
          if (value > this.order.invoice.ClubViewModel.AvailableCredit) this.setValue("UseCredit", this.order.invoice.ClubViewModel.AvailableCredit);
          else {
            this.order.invoice.ClubViewModel.usedCredit = value;
            this.order.invoice.ClubViewModel.isDisableusedCredit = true;
          }
        }
      }
    }
  }
  ChangeInput(event) {
    this.order.invoice.ClubViewModel.ClubTotalDiscount = Number(event.target.value);
  }
  /// SetInputNumber By
  SetInputNumber(numberValue: string) {
    switch (this.clubAction) {
      case ClubEnum.Code:
        if (!this.formGroup.controls["CreditCode"]?.value) {
          this.setValue("CreditCode", numberValue);
        } else
          this.setValue("CreditCode", !this.formGroup.controls["CreditCode"]?.value ? "" : this.formGroup.controls["CreditCode"].value + numberValue);
        break;
      case ClubEnum.UseCredit:
        if (!this.formGroup.controls["UseCredit"]?.value) {
          this.setValue("UseCredit", numberValue);
        } else
          this.setValue("UseCredit", !this.formGroup.controls["UseCredit"]?.value ? "" : this.formGroup.controls["UseCredit"].value + numberValue);
        break;
      case ClubEnum.Mobile:
        if (!this.formGroup.controls["Phone"]?.value) {
          this.setValue("Phone", numberValue);
        } else this.setValue("Phone", !this.formGroup.controls["Phone"]?.value ? "" : this.formGroup.controls["Phone"].value + numberValue);
        break;
      case ClubEnum.SupportNumber:
        if (!this.formGroup.controls["OperatorPhone"]?.value) {
          this.setValue("OperatorPhone", numberValue);
        } else
          this.setValue(
            "OperatorPhone",
            !this.formGroup.controls["OperatorPhone"]?.value ? "" : this.formGroup.controls["OperatorPhone"].value + numberValue
          );
        break;
      default:
        break;
    }
  }
  DeleteInputNumber() {
    switch (this.clubAction) {
      case ClubEnum.Code:
        this.setValue("CreditCode", "");
        break;
      case ClubEnum.UseCredit:
        this.setValue("UseCredit", "");
        break;
      case ClubEnum.Mobile:
        this.setValue("Phone", "");
        break;
      case ClubEnum.SupportNumber:
        this.setValue("OperatorPhone", "");
        break;
      default:
        break;
    }
  }
  BackInputNumber() {
    let name: string = "";
    switch (this.clubAction) {
      case ClubEnum.Code:
        name = "CreditCode";
        break;
      case ClubEnum.UseCredit:
        name = "CreditCode";
        break;
      case ClubEnum.Mobile:
        name = "Phone";
        break;
      case ClubEnum.SupportNumber:
        name = "OperatorPhone";
        break;
      default:
        break;
    }
    const EndString = this.formGroup?.controls[name]?.value?.length - 1;
    this.setValue(name, this.formGroup.controls[name].value.substring(0, EndString));
  }
  Reset() {
    this.order.invoice.HasClub = false;
    this.order.invoice.ClubCode = null;
    this.order.invoice.ClubViewModel = null;
    this.order.invoice.ClubViewModel = new ClubViewModel();
    this.setValue("CreditCode", this.order.invoice.ClubViewModel?.Code);
    this.setValue("Phone", this.order.invoice.ClubViewModel?.LongMobile);
    this.setValue("UseCredit", null);
    this.order.formGroup.controls["Discount"].setValue(0);
    this.order.invoice.IsDiscountPercent = false;
    this.order.invoice.DiscountPrice = 0;
    this.order.invoice.Discount = 0;
    this.order.calculate();
  }
  HealthCheckClub() {
    this.order.splashFormService.openDialog();
    const branchId = this.order.logInBranch.Id;
    this.httpCommonService
      .getList(`Invoice/HealthCheckClub/${branchId}`)
      .pipe(take(1))
      .subscribe((data: number) => {
        this.order.splashFormService.closeLoading();
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.CommunicationWithCustomerClubEstablished"),
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Message")
        );
        console.log(`time:${data}`);
      });
  }
  NeedSmartSupport() {
    if (!this.formGroup.controls["OperatorPhone"].value) {
      this.sts.showToast(
        "warning",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.PhoneNotEntered")
      );
      return;
    }
    this.order.splashFormService.openDialog();
    const branchId = this.order.logInBranch.Id;
    const phone = this.formGroup.controls["OperatorPhone"].value;
    this.httpCommonService
      .getList(`Invoice/NeedSmartSupport/${phone}/${branchId}`)
      .pipe(take(1))
      .subscribe((data: number) => {
        this.order.splashFormService.closeLoading();
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.SupportRequestSentToRelevantUnit"),
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Error")
        );
      });
  }
  GetCustomerByFilter(Code: string) {
    let mobile = Code;

    this.httpCommonService
      .get(`Customer/ReadCustomerByMobile/${mobile}`)
      .pipe(take(1))
      .subscribe(
        (x: Customer) => {
          this.order.invoice.CustomerId = x.Id;
          this.order.invoice.Customer = x;
          this.order.invoice.CustomerDisplayName = x.DisplayName;
          this.order.invoice.PhoneNumber = x.PhoneNumber;
          this.order.invoice.PhoneId = x.Numbers[0].Id;
          this.order.invoice.CustomerAddres = x.Address;
          this.order.invoice.AddressId = x.Addresses[0].Id;
          this.order.invoice.CustomerAddress = x.Addresses[0];
        },
        (e) => console.error(e),
        () => {
          this.sts.showToast(
            "info",
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Invoice"),
            `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Customer")} ${
              this.order.invoice.CustomerDisplayName
            } ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Validated")}`,
            5000
          );
          this.cd.markForCheck();
        }
      );
  }
  ClubCodeChange($event) {
    if (!this.order.saleMethodBranch.UseMobileInValidation) {
      const patternKey = `^[1-9]\\d{1,20}`;
      this.formGroup.controls["CreditCode"].setValidators([Validators.pattern(patternKey)]);
    }
  }

  reset(): void {
    this.id = 0;
    this.isNewRow = true;
    if (!this.id || this.id <= 0) this.setMaxCode();
  }
}
